module.exports = __webpack_public_path__ + "static/media/plantillacliente.9d02f6c0.xlsx";